import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../../utils/styleHelpers';

export interface EngagementStepFooterProps {
  onCancel?: () => void;
  onBack?: () => void;
  onSaveAndQuit: () => void;
  onNext?: () => void;
  saving?: boolean;
}

export const EngagementStepFooter = ({
  onCancel,
  onBack,
  onSaveAndQuit,
  onNext,
  saving
}: EngagementStepFooterProps) => (
  <div className="flex items-center justify-between pt-3">
    <div>
      {onCancel && (
        <button
          type="button"
          className={DEFAULT_CANCEL_BUTTON_STYLE}
          onClick={onCancel}
          disabled={saving}>
          Cancel
        </button>
      )}
      {onBack && (
        <button
          type="button"
          className={DEFAULT_CANCEL_BUTTON_STYLE}
          onClick={onBack}
          disabled={saving}>
          Back
        </button>
      )}
    </div>
    <div className="flex items-center gap-2">
      <button
        type="button"
        className={DEFAULT_CANCEL_BUTTON_STYLE}
        onClick={onSaveAndQuit}
        disabled={saving}>
        Save and Quit
      </button>
      {onNext && (
        <button
          type="button"
          className={DEFAULT_ADVANCE_BUTTON_STYLE}
          onClick={onNext}
          disabled={saving}>
          Next
        </button>
      )}
    </div>
  </div>
);
